<script>
  // original vRoot/rfp-manager/core/rfp-manager-dropdown-actions.vue is used in a lot of places
  import {createEventDispatcher} from 'svelte';
  import RbDropdown from 'root/components/molecules/RbDropdownBounded.svelte';

  export let
    value = {},
    valueIcon = null,
    items = [],
    align = 'bottom-start',
    noItemsMessage = 'No Options Available!',
    mode = 'Dark',
    grow = false;

  const dispatch = createEventDispatcher();

  let opened = false;

  function toggle(){
    opened = !opened;
  }

  function select(item){
    dispatch('input', item);
    toggle();
  }

</script>


<div class="RfpManagerDropDownActions" class:Light={mode === 'Light'} class:Grow={grow}>
  <!-- {#if $$slots.label} TODO: $$slots doesn't work until Svelte 3.25-->
  <label>
    <slot name="label" />
  </label>
  <!--{/if}-->

  <RbDropdown
    isOpen="{opened}"
    {align}
    on:close={toggle}
  >
    <div slot="toggler"
         class="RfpManagerToggle"
         on:click="{toggle}"
         data-icon-before="{valueIcon == null ? null : valueIcon}"
         data-icon-after="{opened ? 'arrow_drop_up' : 'arrow_drop_down'}"
    >
      <div class="RfpManagerToggleValue">
        <slot name="value" />
      </div>
    </div>

    <div class="Menu" slot="dropdown">
      {#each items as item}
        <div
          class="MenuItem"
          class:Selected="{item.id === value.id}"
          data-icon-before="{item.icon == null ? null : item.icon}"
          on:click="{() => select(item)}"
        >
          {@html item.label}
        </div>
      {:else}
        <div class="NoItemsMessage">
          { noItemsMessage }
        </div>
      {/each}
    </div>
  </RbDropdown>
</div>

<style lang="stylus">
  .RfpManagerDropDownActions {
    max-width: 180px;
    font-size: 11px;
    line-height: 18px;

    --RfpManagerDropDownActions-background: linear-gradient(180deg, #2b393f 0%, #2b393f 86.27%, #263238 90%);
    --RfpManagerDropDownActions-border: #16272b;
    --RfpManagerDropDownActions-color: #90A4AE;

    --RfpManagerDropDownActions-hover-background: #263238;
    --RfpManagerDropDownActions-hover-color: white;

    --RfpManagerDropDownActions-menu-background: #263238;
    --RfpManagerDropDownActions-menu-border: #16272b;
    --RfpManagerDropDownActions-menu-color: #90a4ae;

    --RfpManagerDropDownActions-menu-item-border: transparent;
    --RfpManagerDropDownActions-menu-item-hover-background: #36474f;
    --RfpManagerDropDownActions-menu-item-hover-border: #16272b;
    --RfpManagerDropDownActions-menu-item-hover-color: #fff;

    &.Light {
      --RfpManagerDropDownActions-background: white linear-gradient(0deg, #f5f6f7 10%, white 11.05%, white 100%);
      --RfpManagerDropDownActions-border: #e5e6e8;
      --RfpManagerDropDownActions-color: #546E7A;

      --RfpManagerDropDownActions-hover-background: white;
      --RfpManagerDropDownActions-hover-color: #546E7A;

      --RfpManagerDropDownActions-menu-background: #fff;
      --RfpManagerDropDownActions-menu-border: #b0bec5;
      --RfpManagerDropDownActions-menu-color: #546E7A;

      --RfpManagerDropDownActions-menu-item-border: #e5e6e8;
      --RfpManagerDropDownActions-menu-item-hover-background: #ECEFF1;
      --RfpManagerDropDownActions-menu-item-hover-border: #b0bec5;
      --RfpManagerDropDownActions-menu-item-hover-color: #546E7A;
    }


    &.Grow {
      max-width: none;
    }
  }

  label {
    color: #90A4AE;
    padding-left: 1px;
    display: block;
  }

  .RfpManagerToggle {
    box-sizing: border-box;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 27px;
    line-height: 27px;
    border-radius: 2px;
    font-size: 12px;

    background: var(--RfpManagerDropDownActions-background);
    border: 1px solid var(--RfpManagerDropDownActions-border);
    color: var(--RfpManagerDropDownActions-color);

    &:before {
      font-size: 18px;
      margin: 0 -2px 0 5px;
    }

    &:after {
      font-size: 18px;
      margin-left: -3px;
    }

    &:hover {
      background: var(--RfpManagerDropDownActions-hover-background);
      color: var(--RfpManagerDropDownActions-hover-color);
    }
  }

  .RfpManagerToggleValue {
    padding: 0 4px;
    min-width: 50px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .Menu {
    min-width: 179px;
    width: max-content;
    box-shadow: rgba(0,0,0,0.5) 0px 1px 5px 0px;
    margin-top: 5px;
    top: 100%;
    border-radius: 3px;
    font-size: 12px;
    max-height: 400px;
    overflow: auto;

    background: var(--RfpManagerDropDownActions-menu-background);
    border: 1px solid var(--RfpManagerDropDownActions-menu-border);
    color: var(--RfpManagerDropDownActions-menu-color);
  }

  .MenuItem {
    padding: 5px;
    cursor: pointer;
    transition: background 0.3s;
    display: flex;
    align-items: center;
    border-bottom: 1px solid var(--RfpManagerDropDownActions-menu-item-border);

    &:hover {
      background: var(--RfpManagerDropDownActions-menu-item-hover-background);
      color: var(--RfpManagerDropDownActions-menu-item-hover-color);
      border-bottom: 1px solid var(--RfpManagerDropDownActions-menu-item-hover-border);
    }

    &:before {
      height: 16px;
      font-size: 16px;
      margin-right: 5px;
    }
  }

  .Selected {

  }

  .NoItemsMessage {
    padding: 10px;
    color: white;
  }
</style>
